<template>
  <RestaurantDeliveriesList/>
</template>
<script>
import RestaurantDeliveriesList from '@/components/modules/restaurant/deliveries/list'
export default {
  name: 'RestaurantDeliveries',
  components: {
    RestaurantDeliveriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/deliveries/list.vue